import services from 'services';
import utils from 'utils';

interface UseOptionsSearchHTable {
  code: boolean;
  hTable: string;
  idDocType: number;
  idCompany: number;
  optionFormat: number;
}

interface Option {
  value: string;
  label: string;
}

export const useOptionsSearchHTable = ({
  code,
  hTable,
  idDocType,
  idCompany,
  optionFormat,
}: UseOptionsSearchHTable) => {
  const loadOptions = async (input: string): Promise<Option[]> => {
    if (!input || input.trim().length < 3) return [];

    const labelType = utils.input.getLabelTypeByKey(optionFormat);
    const concatLabelValue = labelType === 'code-description';
    const labelField = labelType.includes('description') ? 'description' : 'code';

    let query = input.trim();

    if (concatLabelValue && query.includes(' - ')) {
      const [codePart, ...labelParts] = query.split(' - ').map((s) => s.trim());
      query = code ? codePart : labelParts.join(' - ');
    }

    try {
      const { data } = await services.searchHtable(hTable, query, idDocType, idCompany);
      if (!Array.isArray(data)) return [];
      return utils.input.buildOptions(data, labelField, 'code', concatLabelValue);
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  return { loadOptions };
};
